import type { Source } from "../types/domain";

export const sources: Source[] = [
  {
    id: "source-vie-publique-front-populaire",
    title: "Le Front populaire",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/19522-quest-ce-que-le-front-populaire",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-assemblee-1936",
    title: "Histoire de l'Assemblée nationale - IIIe Republique",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-bnf-blum",
    title: "Leon Blum",
    publisher: "Bibliothèque nationale de France - data.bnf.fr",
    url: "https://data.bnf.fr/fr/11951313/leon_blum/",
    type: "bibliotheque",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-1958",
    title: "La Constitution du 4 octobre 1958",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/19545-la-constitution-du-4-octobre-1958",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-conseil-constitutionnel-1958",
    title: "Constitution du 4 octobre 1958",
    publisher: "Conseil constitutionnel",
    url: "https://www.conseil-constitutionnel.fr/le-bloc-de-constitutionnalite/constitution-du-4-octobre-1958",
    type: "source_primaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-pcf-histoire",
    title: "Repères historiques du Parti communiste français",
    publisher: "Parti communiste français",
    url: "https://www.pcf.fr/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane à confronter avec des sources institutionnelles ou scientifiques."
  },
  {
    id: "source-maitron-tours",
    title: "Congrès de Tours",
    publisher: "Le Maitron",
    url: "https://maitron.fr/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-parti-radical",
    title: "Parti radical (France ; 1901-....)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052068",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-larousse-parti-radical",
    title: "Parti radical et radical-socialiste",
    publisher: "Larousse",
    url: "https://www.larousse.fr/encyclopedie/divers/Parti_radical_et_radical-socialiste/103203",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-federation-republicaine",
    title: "Fédération républicaine (France ; 1903-1948)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052534",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-openedition-alp",
    title: "L'Action libérale populaire et l'illusion du parti politique (1901-1906)",
    publisher: "OpenEdition Books - Éditions de la Sorbonne",
    url: "https://books.openedition.org/psorbonne/60664",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-jaures",
    title: "Jaurès, Jean (1859-1914)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052463",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-wikisource-jaures-1903",
    title: "Discours à la jeunesse (1903)",
    author: "Jean Jaurès",
    publisher: "Wikisource",
    url: "https://fr.wikisource.org/wiki/Discours_%C3%A0_la_jeunesse_(1903)",
    publicationDate: "1903-07",
    accessDate: "2026-08-27",
    type: "source_primaire",
    license: "Domaine public ; transcription Wikisource sous CC BY-SA",
    notes: "Transcription validée du discours prononcé lors de la distribution des prix du lycée d'Albi."
  },
  {
    id: "source-wikisource-lafargue-paresse",
    title: "Le Droit à la paresse",
    author: "Paul Lafargue",
    publisher: "Wikisource",
    url: "https://fr.wikisource.org/wiki/Le_Droit_%C3%A0_la_paresse",
    publicationDate: "1883",
    accessDate: "2026-08-27",
    type: "source_primaire",
    license: "Domaine public ; transcription Wikisource sous CC BY-SA",
    notes: "Transcription validée de l'édition de 1883."
  },
  {
    id: "source-wikisource-guesde-deux-methodes",
    title: "Les Deux Méthodes",
    author: "Jules Guesde",
    publisher: "Wikisource",
    url: "https://fr.wikisource.org/wiki/Les_Deux_M%C3%A9thodes_(Guesde)",
    publicationDate: "1900-11-26",
    accessDate: "2026-08-27",
    type: "source_primaire",
    license: "Domaine public ; transcription Wikisource sous CC BY-SA",
    notes: "Transcription validée du discours contradictoire prononcé à Lille."
  },
  {
    id: "source-wikisource-briand-1927",
    title: "Message au peuple américain",
    author: "Aristide Briand",
    publisher: "Wikisource",
    url: "https://fr.wikisource.org/wiki/Message_au_peuple_am%C3%A9ricain_(Aristide_Briand,_6_avril_1927)",
    publicationDate: "1927-04-06",
    accessDate: "2026-08-27",
    type: "source_primaire",
    license: "Domaine public ; transcription Wikisource sous CC BY-SA",
    notes: "Transcription validée du message adressé au peuple américain."
  },
  {
    id: "source-sanson-alliance-democratique",
    title: "L'Alliance républicaine démocratique : Association et/ou parti ?",
    author: "Rosemonde Sanson",
    publisher: "Publications de la Sorbonne",
    publicationDate: "2001",
    type: "article_scientifique",
    accessDate: "2026-08-24",
    notes: "Référence bibliographique utilisée pour qualifier la forme organisationnelle et l'évolution de l'Alliance."
  },
  {
    id: "source-gallica-psdf-commentry",
    title: "Compte rendu du 1er Congrès national, tenu à Commentry les 26, 27 et 28 septembre 1902",
    publisher: "Gallica - Bibliothèque nationale de France",
    url: "https://gallica.bnf.fr/ark:/12148/bpt6k85249q/",
    type: "source_primaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-theses-prs",
    title: "Le Parti républicain-socialiste de 1911 à 1934",
    publisher: "Theses.fr",
    url: "https://theses.fr/1993PA040197",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-larousse-action-francaise",
    title: "L'Action française",
    publisher: "Larousse",
    url: "https://www.larousse.fr/encyclopedie/divers/l_Action_fran%C3%A7aise/103989",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-hal-action-francaise",
    title: "Naissance de l'Action française. Maurice Barrès, Charles Maurras...",
    publisher: "HAL",
    url: "https://hal.science/hal-01232466",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-assemblee-bloc-national-1919",
    title: "L'après-guerre : chambre bleu horizon, cartel des gauches, union nationale, concentration républicaine",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire-et-patrimoine/troisieme-republique/l-apres-guerre-chambre-bleu-horizon-cartel-des-gauches-union-nationale-concentration-republicaine",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-larousse-bloc-national",
    title: "Bloc national",
    publisher: "Larousse",
    url: "https://www.larousse.fr/encyclopedie/divers/Bloc_national/109135",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-prs",
    title: "Un parti républicain-socialiste a vraiment existé",
    publisher: "Persée - Vingtième Siècle. Revue d'histoire",
    url: "https://www.persee.fr/doc/xxs_0294-1759_1996_num_51_1_4456",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-mouvement-socialiste",
    title: "Claude Willard, Le mouvement socialiste en France (1893-1905)",
    publisher: "Persée - Revue d'histoire moderne et contemporaine",
    url: "https://www.persee.fr/doc/rhmc_0048-8003_1968_num_15_2_2996",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-marxists-pof-programme",
    title: "Programme of the French Workers' Party",
    publisher: "Marxists Internet Archive",
    url: "https://www.marxists.org/archive/marx/works/1880/05/parti-ouvrier.htm",
    type: "source_primaire",
    accessDate: "2026-08-24",
    notes: "Source militante/édition documentaire à contextualiser ; utilisée comme document programmatique historique."
  },
  {
    id: "source-theses-deroulede",
    title: "Paul Déroulède (1846-1914)",
    publisher: "Theses.fr",
    url: "https://theses.fr/1996PA040127",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-theses-jeunesses-patriotes",
    title: "Le temps des ligues : Pierre Taittinger et les Jeunesses Patriotes",
    publisher: "Theses.fr",
    url: "https://theses.fr/2000IEPP0009",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-archives-loire-atlantique-jp",
    title: "Fonds des Jeunesses patriotes",
    publisher: "Archives départementales de Loire-Atlantique",
    url: "https://inventaires-archives.loire-atlantique.fr/ead.html?id=FRAD044_58Fi",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-pdp",
    title: "Raymond Laurent, Le Parti Démocrate Populaire, 1924-1944",
    publisher: "Persée - Revue du Nord",
    url: "https://www.persee.fr/doc/rnord_0035-2624_1966_num_48_188_5738_t1_0130_0000_1",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-maitron-sangnier",
    title: "SANGNIER Marc",
    publisher: "Le Maitron",
    url: "https://maitron.fr/sangnier-marc/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-faisceau",
    title: "Anatomie d'un mouvement fasciste en France : le Faisceau de Georges Valois",
    author: "Zeev Sternhell",
    publisher: "Persée - Revue française de science politique",
    url: "https://www.persee.fr/doc/rfsp_0035-2950_1976_num_26_1_393652",
    publicationDate: "1976",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-action-francaise-1926",
    title: "La condamnation de l'Action française par Pie XI",
    author: "Jacques Prévotat",
    publisher: "Persée - École française de Rome",
    url: "https://www.persee.fr/doc/efr_0223-5099_1996_act_223_1_5038",
    publicationDate: "1996",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-jstor-cartel-socialistes",
    title: "The French Socialist and the Cartel des Gauches of 1924",
    publisher: "JSTOR",
    url: "https://www.jstor.org/stable/260257",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-france-memoire-herriot-cartel",
    title: "L'homme du Cartel (1924-1926)",
    publisher: "France Mémoire",
    url: "https://www.france-memoire.fr/herriot-et-le-cartel-des-gauches/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-ldh-histoire",
    title: "Histoire de la Ligue des droits de l'Homme",
    publisher: "Ligue des droits de l'Homme",
    url: "https://www.ldh-france.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source associative à contextualiser et à croiser."
  },
  {
    id: "source-cagoule-historytoday",
    title: "The Cagoulard Conspiracy",
    author: "Geoffrey Warner",
    publisher: "History Today",
    publicationDate: "1960-07",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-psop",
    title: "Parti socialiste ouvrier et paysan (France ; 1938-1940)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052624",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-bataille-socialiste-psop",
    title: "Conférence constitutive du PSOP",
    publisher: "La Bataille socialiste",
    url: "https://bataillesocialiste.wordpress.com/documents-historiques/1938-07-conference-constitutive-du-psop/",
    type: "source_primaire",
    accessDate: "2026-08-24",
    notes: "Reproduction militante d'un document historique ; à contextualiser."
  },
  {
    id: "source-cambridge-neosocialisme",
    title: "The Vicissitudes of Neo-Socialism",
    publisher: "Cambridge University Press",
    url: "https://www.cambridge.org/core/books/order-authority-nation/vicissitudes-of-neosocialism/7D464D2AB416E35D3AC04C804980EDED",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-1914-1918-croix-de-feu",
    title: "Croix-de-Feu",
    publisher: "1914-1918 Online. International Encyclopedia of the First World War",
    url: "https://encyclopedia.1914-1918-online.net/article/croix-de-feu/",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-erudit-croix-de-feu-psf",
    title: "Pitfalls of Paramilitarism: The Croix de Feu, the Parti Social Français, and the French State, 1934-39",
    publisher: "Journal of Conflict Studies / Érudit",
    url: "https://www.erudit.org/en/journals/jcs/2007-v27-n2-jcs_27_2/jcs27_2art05/",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-ppf",
    title: "Parti populaire français (1936-1945)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052632",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-larousse-ppf",
    title: "PPF, sigle de Parti populaire français",
    publisher: "Larousse",
    url: "https://www.larousse.fr/encyclopedie/divers/PPF/139461",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-bucard",
    title: "Bucard, Marcel (1895-1946)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/agent/18799389",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-larousse-6-fevrier-1934",
    title: "6 février 1934",
    publisher: "Larousse",
    url: "https://www.larousse.fr/encyclopedie/divers/6_f%C3%A9vrier_1934/119133",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-assemblee-pleins-pouvoirs-1940",
    title: "Annexe au procès-verbal de la séance du mercredi 10 juillet 1940",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/histoire/7juillet1940.asp",
    type: "source_primaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-vichy-resistance",
    title: "Vichy et la Résistance (1940-1944) : deux légitimités concurrentes",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/268978-regime-de-vichy-et-resistance-1940-1944",
    type: "institution",
    accessDate: "2026-08-25"
  },
  {
    id: "source-francearchives-mrp",
    title: "Mouvement républicain populaire (France ; 1944-1967)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/authorityrecord/FRAN_NP_052592",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-cnip",
    title: "Centre national des indépendants et paysans (France ; 1949-....)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052594",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-theses-cnip",
    title: "Le Centre national des indépendants et paysans : 1948-1962",
    publisher: "Theses.fr",
    url: "https://theses.fr/1992PA100069",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-udsr",
    title: "Union démocratique et socialiste de la Résistance",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052069",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-sciencespo-udsr",
    title: "Union démocratique et socialiste de la Résistance",
    publisher: "Archives de Sciences Po",
    url: "https://archives.sciencespo.fr/ark:/46513/581963",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-fondation-de-gaulle-rpf",
    title: "Le 14 avril 1947, le général de Gaulle lance le Rassemblement du peuple français",
    publisher: "Fondation Charles de Gaulle",
    url: "https://www.charles-de-gaulle.org/lhomme/dossiers-thematiques/lopposition-a-ive-republique-1946-1958/affiche-rassemblement-peuple-francais-avril-1947/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-unr",
    title: "Union pour la Nouvelle République (1958-1967)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052130",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-bnf-unr-udt",
    title: "Notice de collectivité : Union pour la nouvelle République (France)",
    publisher: "Bibliothèque nationale de France",
    url: "https://catalogue.bnf.fr/ark:/12148/cb12304525n",
    type: "bibliotheque",
    accessDate: "2026-08-26",
    notes: "La notice documente les dénominations successives UNR, UNR-UDT puis UD-Ve et la fusion avec l'UDT."
  },
  {
    id: "source-assemblee-unr-udt",
    title: "Députés de la IIe législature (1962-1967) : groupe UNR-UDT",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/2/deputes2.asp",
    type: "institution",
    accessDate: "2026-08-26"
  },
  {
    id: "source-archives-nationales-1958",
    title: "1958. D'une République à l'autre",
    publisher: "Archives nationales",
    url: "https://www.archives-nationales.culture.gouv.fr/dossiers-thematiques/1958-dune-republique-lautre",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-psu",
    title: "Parti socialiste unifié (France ; 1960-1989)",
    publisher: "FranceArchives / Archives nationales",
    url: "https://rdf.archives-nationales.culture.gouv.fr/garance/entities/agent/050235/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-psa",
    title: "Parti socialiste autonome",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/facomponent/b57915431b67b3f6197821bc6f361ce99009d862",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-maitron-depreux",
    title: "DEPREUX Édouard, Gustave, Hector",
    publisher: "Le Maitron",
    url: "https://maitron.fr/depreux-edouard-gustave-hector/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-openedition-prl",
    title: "Le Parti Républicain de la Liberté (PRL) ou l'impossible union des droites",
    publisher: "OpenEdition Books - Presses universitaires de Rennes",
    url: "https://books.openedition.org/pur/16309",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-jeune-nation-sidos",
    title: "Jeune Nation",
    publisher: "Notice encyclopédique à vérifier par sources archivistiques",
    url: "https://fr.wikipedia.org/wiki/Jeune_Nation",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source provisoire pour cadrage chronologique ; à remplacer par fonds d'archives ou ouvrage scientifique."
  },
  {
    id: "source-oas-herodote",
    title: "11 février 1961 - Création de l'OAS",
    publisher: "Herodote.net",
    url: "https://www.herodote.net/almanach-ID-3363.php",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-maitron-bleibtreu",
    title: "BLEIBTREU Marcel",
    publisher: "Le Maitron",
    url: "https://fusilles-40-44.maitron.fr/bleibtreu-marcel-pseudonymes-vierny-tanguy-antoine-a-partir-de-1940-pierre-favre-a-partir-de-1947/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-centre-democrate",
    title: "Centre démocrate (France ; 1966-1976)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_050624",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-centre-democrate",
    title: "Les paradoxes du Centre démocrate",
    publisher: "Persée - Revue française de science politique",
    url: "https://www.persee.fr/doc/rfsp_0035-2950_1966_num_16_5_392965",
    publicationDate: "1966",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-republicains-independants",
    title: "M. Valéry Giscard d'Estaing et les républicains indépendants : réalités et perspectives",
    author: "Marie-Christine Kessler",
    publisher: "Persée - Revue française de science politique",
    url: "https://www.persee.fr/doc/rfsp_0035-2950_1966_num_16_5_392964",
    publicationDate: "1966",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-archives-socialistes-1969",
    title: "Les congrès du Parti socialiste 1969-2021",
    publisher: "Archives socialistes",
    url: "https://archives-socialistes.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-referendum-1962",
    title: "La révision constitutionnelle et le référendum de 1962",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/38016-la-revision-constitutionnelle-et-le-referendum-de-1962",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-conseil-constitutionnel-1962",
    title: "Décision n° 62-20 DC du 6 novembre 1962",
    publisher: "Conseil constitutionnel",
    url: "https://www.conseil-constitutionnel.fr/decision/1962/6220DC.htm",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-senat-referendum-1969",
    title: "Décret n°69-296 du 2 avril 1969 décidant de soumettre un projet de loi au référendum",
    publisher: "Sénat",
    url: "https://www.senat.fr/connaitre-le-senat/evenements-et-manifestations-culturelles/les-revisions-de-la-constitution/decret-n69-296-du-2-avril-1969-decidant-de-soumettre-un-projet-de-loi-au-referendum-extraits.html",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-persee-mouvement-22-mars",
    title: "Le mouvement du 22 mars. Entretien avec Daniel Cohn-Bendit",
    publisher: "Persée - Matériaux pour l'histoire de notre temps",
    url: "https://www.persee.fr/doc/mat_0769-3206_1988_num_11_1_403840",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-paris8-gauche-proletarienne",
    title: "La Gauche prolétarienne (1968-1973)",
    publisher: "Octaviana - Université Paris 8",
    url: "https://octaviana.fr/s/octaviana/item/171631",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-maitron-krivine",
    title: "KRIVINE Alain",
    publisher: "Le Maitron",
    url: "https://maitron.fr/krivine-alain-dit-eric-delphin-tinville-george-villetin/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-gis-gauche-proletarienne",
    title: "Un mouvement maoïste en France : la Gauche prolétarienne, 1968-1973",
    publisher: "GIS Réseau Asie / Sciences Po",
    url: "https://www.gis-reseau-asie.org/en/thesis/un-mouvement-maoiste-en-france-la-gauche-proletarienne-1968-1973",
    type: "article_scientifique",
    accessDate: "2026-08-24"
  },
  {
    id: "source-mahj-cohn-bendit",
    title: "Cohn-Bendit manifestant à Paris le 13 mai 1968",
    publisher: "mahJ",
    url: "https://www.mahj.org/en/decouvrir-collections-betsalel/cohn-bendit-manifestant-paris-le-13-mai-1968-9209",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-parti-occitan",
    title: "What is the Partit Occitan?",
    publisher: "Partit Occitan",
    url: "https://partitoccitan.org/archivas/article925.html?lang=en",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane utilisée pour corriger la date du Partit Occitan : le parti actuel date de 1987, pas de 1959."
  },
  {
    id: "source-pno",
    title: "Partit de la Nacion Occitana",
    publisher: "Notice encyclopédique à vérifier",
    url: "https://en.wikipedia.org/wiki/Partit_de_la_Nacion_Occitana",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source provisoire ; à remplacer par une source académique ou archivistique."
  },
  {
    id: "source-francearchives-udf",
    title: "Union pour la démocratie française",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/agent/221596992",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-cds",
    title: "Centre des démocrates sociaux (France ; 1976-1995)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_050625",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-rpr",
    title: "Rassemblement pour la République (France ; 1976-2002)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/fr/authorityrecord/FRAN_NP_052768",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-fondation-jean-jaures-le-pen",
    title: "Jean-Marie Le Pen (1928-2025): an attempt to assess a political life",
    publisher: "Fondation Jean-Jaurès",
    url: "https://www.jean-jaures.org/publication/jean-marie-le-pen-1928-2025-an-attempt-to-assess-a-political-life/",
    type: "source_secondaire",
    accessDate: "2026-08-24"
  },
  {
    id: "source-prg-histoire",
    title: "Notre histoire : deux siècles de radicalisme",
    publisher: "Parti radical de gauche",
    url: "https://www.partiradicaldegauche.fr/notre-histoire/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane utilisée pour la chronologie interne du MRG/PRG ; à croiser avec des archives."
  },
  {
    id: "source-perspective-ri",
    title: "Républicains indépendants - France",
    publisher: "Perspective Monde - Université de Sherbrooke",
    url: "https://perspective.usherbrooke.ca/bilan/servlet/BMParti?codeParti=ri&codePays=FRA",
    type: "base_de_donnees",
    accessDate: "2026-08-24"
  },
  {
    id: "source-ina-lutte-ouvriere-1974",
    title: "Arlette Laguiller, campagne Lutte ouvrière 1974",
    publisher: "INA",
    url: "https://www.ina.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-mlac-histoire",
    title: "Mouvement pour la liberté de l'avortement et de la contraception",
    publisher: "Notice documentaire à vérifier",
    url: "https://fr.wikipedia.org/wiki/Mouvement_pour_la_libert%C3%A9_de_l%27avortement_et_de_la_contraception",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source provisoire pour cadrage chronologique ; à remplacer par source archivistique ou scientifique."
  },
  {
    id: "source-europe-ecologie-1979",
    title: "Écologie politique française et élections européennes de 1979",
    publisher: "Notice documentaire à vérifier",
    url: "https://fr.wikipedia.org/wiki/Europe_%C3%89cologie_(1979)",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source provisoire ; ne pas intégrer de résultats chiffrés sans source officielle."
  },
  {
    id: "source-lo-histoire",
    title: "Lutte ouvrière - repères historiques",
    publisher: "Lutte ouvrière",
    url: "https://www.lutte-ouvriere.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane à croiser avec sources archivistiques."
  },
  {
    id: "source-vie-publique-mitterrand-1981",
    title: "L'élection présidentielle de 1981",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/19553-lelection-presidentielle-de-1981",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-cohabitation-1986",
    title: "La première cohabitation (1986-1988)",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/fiches/19554-la-premiere-cohabitation-1986-1988",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-decentralisation",
    title: "Les lois de décentralisation de 1982-1983",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/eclairage/38447-les-lois-de-decentralisation-de-1982-1983",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-assemblee-legislatives-1988",
    title: "Les élections législatives sous la Ve République",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire-et-patrimoine/les-elections-legislatives",
    type: "institution",
    accessDate: "2026-08-24",
    notes: "Source institutionnelle de cadrage ; les résultats détaillés devront être rapprochés des données électorales officielles."
  },
  {
    id: "source-francearchives-verts",
    title: "Les Verts (France ; 1984-2010)",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique à préciser ; utilisée ici pour le cadrage de la formation écologiste."
  },
  {
    id: "source-fondation-jean-jaures-fn-1984",
    title: "La percée électorale du Front national dans les années 1980",
    publisher: "Fondation Jean-Jaurès",
    url: "https://www.jean-jaures.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source de cadrage ; ne remplace pas une table officielle pour les pourcentages et sièges."
  },
  {
    id: "source-maitron-parti-travailleurs",
    title: "Parti des travailleurs et courant lambertiste",
    publisher: "Le Maitron",
    url: "https://maitron.fr/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source de cadrage historique pour une organisation dont la chronologie et les appellations évoluent."
  },
  {
    id: "source-parti-occitan-1987",
    title: "Histoire du Parti occitan",
    publisher: "Parti occitan",
    url: "https://partitoccitan.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane à croiser avec des travaux universitaires."
  },
  {
    id: "source-cuncolta-naziunale",
    title: "A Cuncolta Naziunale",
    publisher: "Encyclopédie de la Corse",
    url: "https://www.encyclopedie.corsica/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source de cadrage provisoire pour le mouvement autonomiste corse."
  },
  {
    id: "source-choisir-feminisme",
    title: "Histoire de Choisir - la cause des femmes",
    publisher: "Choisir - la cause des femmes",
    url: "https://choisirlacausedesfemmes.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source associative et partisane au sens large ; utilisée pour qualifier le mouvement féministe."
  },
  {
    id: "source-vie-publique-maastricht",
    title: "Le traité de Maastricht",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/eclairage/19387-le-traite-de-maastricht",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-gauche-plurielle",
    title: "La gauche plurielle (1997-2002)",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24",
    notes: "Source institutionnelle de cadrage ; les résultats et la composition détaillée seront à préciser."
  },
  {
    id: "source-vie-publique-chirac-1995",
    title: "L'élection présidentielle de 1995",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-mdc",
    title: "Mouvement des citoyens",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique utilisée pour le cadrage du MDC et de sa filiation chevènementiste."
  },
  {
    id: "source-francearchives-rpf-1999",
    title: "Rassemblement pour la France",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique rappelant que le RPF de 1999 est distinct du RPF gaulliste de 1947."
  },
  {
    id: "source-francearchives-mpf",
    title: "Mouvement pour la France",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-cpnt",
    title: "Chasse, pêche, nature et traditions",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Source de cadrage provisoire pour une formation représentant des intérêts ruraux et cynégétiques."
  },
  {
    id: "source-francearchives-mnr",
    title: "Mouvement national républicain",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique de cadrage pour la scission du FN en 1998-1999."
  },
  {
    id: "source-francearchives-democratie-liberale",
    title: "Démocratie libérale",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Source de cadrage provisoire pour la formation libérale issue de l'UDF."
  },
  {
    id: "source-francearchives-1990s-elections",
    title: "Archives électorales de la Ve République",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire-et-patrimoine/les-elections-legislatives",
    type: "institution",
    accessDate: "2026-08-24",
    notes: "Source de cadrage historique, complétée dans les fiches électorales par les archives de résultats institutionnelles."
  },
  {
    id: "source-vie-publique-presidentielle-2002",
    title: "L'élection présidentielle de 2002",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24",
    notes: "Source institutionnelle de cadrage ; les résultats détaillés doivent être rapprochés des données électorales officielles."
  },
  {
    id: "source-vie-publique-presidentielle-2007",
    title: "L'élection présidentielle de 2007",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-ump",
    title: "Union pour un mouvement populaire",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24",
    notes: "Source de cadrage institutionnelle pour la création de l'UMP et la majorité présidentielle."
  },
  {
    id: "source-francearchives-modem",
    title: "Mouvement démocrate",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique de cadrage pour la transformation de l'UDF en MoDem."
  },
  {
    id: "source-francearchives-npa",
    title: "Nouveau Parti anticapitaliste",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Source de cadrage provisoire pour la création du NPA en 2009."
  },
  {
    id: "source-francearchives-mrc",
    title: "Mouvement républicain et citoyen",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-front-gauche",
    title: "Front de gauche",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Source de cadrage provisoire pour l'alliance constituée en 2008-2009."
  },
  {
    id: "source-europe-ecologie-2009",
    title: "Europe Écologie aux élections européennes de 2009",
    publisher: "Fondation de l'écologie politique",
    url: "https://www.fondationecolo.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source de cadrage ; les résultats chiffrés doivent être vérifiés auprès des résultats électoraux officiels."
  },
  {
    id: "source-francearchives-eelv",
    title: "Europe Écologie Les Verts",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-attac-histoire",
    title: "Histoire et statuts d'ATTAC",
    publisher: "ATTAC France",
    url: "https://france.attac.org/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source associative à croiser avec des travaux sur l'altermondialisme."
  },
  {
    id: "source-vie-publique-hollande-2012",
    title: "L'élection présidentielle de 2012",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-macron-2017",
    title: "L'élection présidentielle de 2017",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-mariage-tous",
    title: "La loi ouvrant le mariage aux couples de même sexe",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-vie-publique-gilets-jaunes",
    title: "Le mouvement des Gilets jaunes",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-lfi",
    title: "La France insoumise",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique de cadrage pour ce mouvement créé en 2016."
  },
  {
    id: "source-francearchives-lrem",
    title: "La République en marche",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Notice archivistique de cadrage pour ce mouvement créé en 2016."
  },
  {
    id: "source-francearchives-lr",
    title: "Les Républicains",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-dlf",
    title: "Debout la France",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24"
  },
  {
    id: "source-upr-histoire",
    title: "Union populaire républicaine",
    publisher: "Union populaire républicaine",
    url: "https://www.upr.fr/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane à croiser avec des sources institutionnelles."
  },
  {
    id: "source-francearchives-rn",
    title: "Rassemblement national et Front national",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Source de cadrage pour le changement de nom du FN en RN en 2018."
  },
  {
    id: "source-parti-animaliste",
    title: "Parti animaliste",
    publisher: "Parti animaliste",
    url: "https://parti-animaliste.fr/",
    type: "source_secondaire",
    accessDate: "2026-08-24",
    notes: "Source partisane à croiser avec les résultats électoraux officiels."
  },
  {
    id: "source-francearchives-parti-animaliste",
    title: "Partis et listes des élections européennes de 2019",
    publisher: "Ministère de l'Intérieur",
    url: "https://www.interieur.gouv.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-francearchives-nupes",
    title: "Nouvelle Union populaire écologique et sociale",
    publisher: "FranceArchives",
    url: "https://francearchives.gouv.fr/",
    type: "archive",
    accessDate: "2026-08-24",
    notes: "Coalition postérieure à la période 2010-2020 ; entrée conservée comme repère de continuité."
  },
  {
    id: "source-vie-publique-covid-2020",
    title: "La crise sanitaire de 2020",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/",
    type: "institution",
    accessDate: "2026-08-24"
  },
  {
    id: "source-assemblee-histoire-elections",
    title: "Troisième République : histoire politique et élections",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire-et-patrimoine/troisieme-republique",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Source institutionnelle de synthèse pour les résultats politiques des élections législatives de l'entre-deux-guerres."
  },
  {
    id: "source-assemblee-quatrieme-republique-elections",
    title: "La Quatrième République : élections et instabilité parlementaire",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/histoire-et-patrimoine/quatrieme-republique/un-regime-instable-1947-1951",
    type: "institution",
    accessDate: "2026-08-27"
  },
  {
    id: "source-assemblee-legislatives-resultats",
    title: "Résultats des élections législatives sous la Ve République",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/histoire/leg5repnew.asp",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Tableaux institutionnels des voix, pourcentages, sièges et groupes parlementaires."
  },
  {
    id: "source-interieur-archives-resultats",
    title: "Archives des résultats des élections en France",
    publisher: "Ministère de l'Intérieur",
    url: "https://www.archives-resultats-elections.interieur.gouv.fr/",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Résultats nationaux officiels des scrutins contemporains."
  },
  {
    id: "source-vie-publique-referendums",
    title: "Le référendum en France en sept questions",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/questions-reponses/290760-le-referendum-en-france-en-sept-questions",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Tableau récapitulatif des référendums de la Ve République établi à partir des proclamations du Conseil constitutionnel."
  },
  {
    id: "source-vie-publique-revisions-constitutionnelles",
    title: "Les révisions constitutionnelles de la Ve République",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/files/2024-04/604240050_INT_Constitution-1958_Maj-2024_Web_Extrait.pdf",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Synthèse institutionnelle comprenant le résultat du référendum constitutionnel du 28 septembre 1958."
  },
  {
    id: "source-vie-publique-resultats-presidentielles",
    title: "Cartes des résultats des élections présidentielles",
    publisher: "Vie publique",
    url: "https://www.vie-publique.fr/bibliotheque-multimedia?type_1=carte",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Collection institutionnelle de cartes et résultats nationaux par tour depuis 1965, à partir des données du ministère de l'Intérieur."
  },
  {
    id: "source-parlement-europeen-resultats",
    title: "Résultats des élections européennes : France",
    publisher: "Parlement européen",
    url: "https://results.elections.europa.eu/fr/resultats-nationaux/france/1979-1984/session-constitutive/",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Résultats et séries historiques des élections européennes en France."
  },
  {
    id: "source-data-gouv-presidentielles-1965-2012",
    title: "Élections présidentielles 1965-2012 par circonscription",
    author: "Centre de données sociopolitiques",
    publisher: "Sciences Po / data.gouv.fr",
    url: "https://www.data.gouv.fr/datasets/elections-presidentielles-1965-2012-1",
    type: "base_de_donnees",
    license: "Open Data Commons Open Database License (ODbL)",
    accessDate: "2026-08-27",
    notes: "Résultats des deux tours agrégés par circonscription ; les données jusqu'en 2002 proviennent de la BDSP/CDSP, celles de 2007 à 2012 du ministère de l'Intérieur."
  },
  {
    id: "source-data-gouv-presidentielle-2017",
    title: "Élection présidentielle 2017 : résultats définitifs du second tour par bureaux de vote",
    publisher: "Ministère de l'Intérieur / data.gouv.fr",
    url: "https://www.data.gouv.fr/datasets/election-presidentielle-des-23-avril-et-7-mai-2017-resultats-definitifs-du-2nd-tour-par-bureaux-de-vote",
    type: "base_de_donnees",
    license: "Licence Ouverte / Open Licence",
    accessDate: "2026-08-27",
    notes: "Résultats définitifs agrégés par département dans HistPoliticor."
  },
  {
    id: "source-data-gouv-legislatives-1958-2012",
    title: "Élections législatives 1958-2012 par circonscription",
    author: "Centre de données sociopolitiques",
    publisher: "Sciences Po / data.gouv.fr",
    url: "https://www.data.gouv.fr/datasets/elections-legislatives-1958-2012",
    type: "base_de_donnees",
    license: "Open Data Commons Open Database License (ODbL)",
    accessDate: "2026-08-27",
    notes: "Résultats par circonscription produits par la BDSP et le ministère de l'Intérieur, puis contrôlés et diffusés par le CDSP."
  },
  {
    id: "source-data-gouv-legislatives-2017",
    title: "Élections législatives 2017 : résultats définitifs du second tour",
    publisher: "Ministère de l'Intérieur / data.gouv.fr",
    url: "https://www.data.gouv.fr/datasets/elections-legislatives-des-11-et-18-juin-2017-resultats-du-2nd-tour",
    type: "base_de_donnees",
    license: "Licence Ouverte / Open Licence",
    accessDate: "2026-08-27",
    notes: "Résultats définitifs par département, incluant participation, voix par nuance et sièges."
  },
  {
    id: "source-assemblee-effectifs-elections",
    title: "Nombre de députés élus aux élections législatives depuis 1876",
    publisher: "Assemblée nationale",
    url: "https://www.assemblee-nationale.fr/dyn/12/questions/QANR5L12QE52861",
    type: "institution",
    accessDate: "2026-08-27",
    notes: "Tableau du ministère de l'Intérieur publié par l'Assemblée nationale ; complété par l'effectif constitutionnel de 577 députés pour les scrutins postérieurs."
  },
  {
    id: "source-etalab-departements",
    title: "Contours administratifs des départements français, édition 2025",
    publisher: "Etalab / data.gouv.fr",
    url: "https://etalab-datasets.geo.data.gouv.fr/contours-administratifs/2025/geojson/",
    type: "base_de_donnees",
    license: "Licence Ouverte / Open Licence",
    accessDate: "2026-08-27",
    notes: "Fond GeoJSON simplifié à 1 000 mètres utilisé pour la carte électorale interactive."
  }
];
